import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import './Scrip.css';

const areas = ['Finance', 'Security', 'IT', 'Health', 'Logistics'];

export default function Scrip({ onRegister }) {
  const ref = useFadeIn();

  return (
    <section id="scrip" className="scrip-section">
      <div className="scrip-inner fade-in" ref={ref}>
        <div className="scrip-left">
          <div className="scrip-eyebrow">Career Opportunity</div>
          <h2 className="scrip-title">
            Strategic Carrier-Readiness Internal Program (SCRIP)
          </h2>
        </div>
        <div className="scrip-right">
          <p className="scrip-body">
            Our SCRIP program bridges the gap between academic intelligence training and
            real-world professional practice. Available to full-time students enrolled in
            accredited intelligence programs, participants complete at least one workshop with
            top-tier industry professionals before graduating — an unmatched launchpad into a
            career in intelligence service.
          </p>
          <div className="scrip-areas">
            {areas.map((a) => (
              <span className="scrip-tag" key={a}>{a}</span>
            ))}
          </div>
          <p className="scrip-note">
            Submit your expression of interest at least <strong>3 weeks</strong> before your
            desired start date. All applicants go through our rigorous due diligence process.
          </p>
          <div className="scrip-actions">
            <button className="btn-dark" onClick={onRegister}>
              Apply to SCRIP →
            </button>
            <span className="scrip-deadline">Due diligence required · 5-step process</span>
          </div>
        </div>
      </div>
    </section>
  );
}









// import React from 'react';
// import { useFadeIn } from '../hooks/useFadeIn';
// import './Scrip.css';

// const areas = ['Finance', 'Security', 'IT', 'Health', 'Logistics'];

// export default function Scrip() {
//   const ref = useFadeIn();

//   return (
//     <section id="scrip" className="scrip-section">
//       <div className="scrip-inner fade-in" ref={ref}>
//         <div className="scrip-left">
//           <div className="scrip-eyebrow">Career Opportunity</div>
//           <h2 className="scrip-title">
//             Strategic Carrier-Readiness Internal Program (SCRIP)
//           </h2>
//         </div>
//         <div className="scrip-right">
//           <p className="scrip-body">
//             Our SCRIP program bridges the gap between academic intelligence training and
//             real-world professional practice. Available to full-time students enrolled in
//             accredited intelligence programs, participants complete at least one workshop with
//             top-tier industry professionals before graduating — an unmatched launchpad into a
//             career in intelligence service.
//           </p>
//           <div className="scrip-areas">
//             {areas.map((a) => (
//               <span className="scrip-tag" key={a}>{a}</span>
//             ))}
//           </div>
//           <p className="scrip-note">
//             Submit your expression of interest at least <strong>3 weeks</strong> before your
//             desired start date. All applicants go through our standard due diligence process.
//           </p>
//           <a href="#contact" className="btn-dark">Apply to SCRIP →</a>
//         </div>
//       </div>
//     </section>
//   );
// }
